export default __webpack_public_path__ + "static/media/ScreenShot_4.320ee3e2.jpg";